import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import Icon from '@src/basic-components/Icon/Icon';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface PinnedIndicatorProps {
    className?: string;
    labelClassName?: string;
}

const PinnedIndicator: FC<PinnedIndicatorProps> = props => {
    const { className = '', labelClassName = '' } = props;
    const { t } = useTranslation();

    return (
        <div className={cn('flex items-center space-x-1 text-yellow-600 dark:text-yellow-500', className)}>
            <Icon name="pin" className="text-base" />
            <Text className={cn('font-medium', labelClassName)}>{t('PinnedIndicator.label')}</Text>
        </div>
    );
};

export default PinnedIndicator;
